import {TableAdditionalComponent} from './table.additional.component';

export const TABLE_COMPONENTS = [
    TableAdditionalComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/table/index.ts